import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { IconSanitizerService } from 'ngx-lib';

@Component({
    selector: 'app-report-scheduler-status-indicator',
    templateUrl: './report-scheduler-status-indicator.component.html',
    styleUrls: ['./report-scheduler-status-indicator.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule]
})
export class ReportSchedulerStatusIndicatorComponent {
    @Input()
    schedulerStatusId?: number;

    scheduleIcon: SafeHtml;

    constructor(private readonly iconSanitizer: IconSanitizerService) {
        this.scheduleIcon = this.iconSanitizer.getIcon('schedule');
    }
}
